import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import CheckoutListItem from './CheckoutListItem';
import CheckoutController, { CheckoutHistoryType } from '../../../controller/CheckoutController';
import { CurrentStoreContext } from '../../../controller/StoreController';

const CheckoutList = () => {
  const navigate = useNavigate();
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  // 0:오늘, 1:어제, 2: 전체
  const [status, setStatus] = useState<number>(0);

  const [checkoutList, setCheckoutList] = useState<CheckoutHistoryType[]>([]);

  const getHotelNoticeHistory = async () => {
    let fromDate = new Date();
    let toDate = new Date();
    try {
      if (status === 2) {
        fromDate.setDate(new Date().getDate() - 6);
      } else if (status === 1) {
        fromDate.setDate(new Date().getDate() - 1);
        toDate.setDate(new Date().getDate() - 1);
      }

      const oParams = {
        store_id: currentStore.value,
        notice_at_from: fromDate,
        notice_at_to: toDate,
      };

      const oResponse = await CheckoutController.getHotelNoticeHistory(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data && oRes.data.history) {
          setCheckoutList([...oRes.data.history]);
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  const getHotelNoticeHistoryDetail = async (item_id: number) => {
    try {
      const oParams = {
        represent_log_id: item_id,
      };

      const oResponse = await CheckoutController.getHotelNoticeHistoryDetail(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          return oRes.data;
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  useEffect(() => {
    getHotelNoticeHistory();
  }, [status]);

  return (
    <>
      <Style>
        <div className={'contentContainer'}>
          <div className="orderTitle">
            <button
              className={`dateButton ${status === 2 && 'active'}`}
              onClick={() => setStatus(2)}>
              전체
            </button>
            <button
              className={`dateButton ${status === 0 && 'active'}`}
              onClick={() => setStatus(0)}>
              오늘
            </button>
            <button
              className={`dateButton ${status === 1 && 'active'}`}
              onClick={() => setStatus(1)}>
              어제
            </button>
          </div>
          <div className="listWrap">
            {checkoutList.length > 0 ? (
              checkoutList.map((item, index) => (
                <CheckoutListItem
                  key={index}
                  item={item}
                  getHotelNoticeHistoryDetail={getHotelNoticeHistoryDetail}
                />
              ))
            ) : (
              <div className="noDataListWrap">
                <h3>알림내역이 없습니다.</h3>
              </div>
            )}
          </div>
        </div>
      </Style>
    </>
  );
};

export default CheckoutList;

const Style = styled.div`
  /* contentContainer */
  .contentContainer {
    max-height: 80vh;
    border-radius: 10px;
    overflow: auto;
    padding: 0 60px;
  }

  .orderTitle {
    position: sticky;
    top: 0;
    width: 100%;
    padding: 30px 0;
    display: flex;
    background: #ffffff;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    z-index: 10;

    .dateButton {
      padding: 6px 28px;
      background: #fff;
      border-radius: 5px;
      color: #979797;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      border: 1px solid #cecece;
    }
    .dateButton.active {
      background: #4dd2ae;
      color: #ffffff;
      border: 1px solid #4dd2ae;
    }
  }

  .noDataListWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 300px;
    justify-content: center;
    align-items: center;
    align-self: center;

    h3 {
      font-size: 20px;
      line-height: 24px;
      color: #999999;
      font-weight: 500;
    }
  }

  @media (max-width: 900px) {
    .contentContainer {
      padding: 0 10px;
      border-radius: 10px;
    }

    .orderTitle {
      padding: 20px 0;
      .dateButton {
        padding: 4px 20px;
      }
    }

    .noDataListWrap {
      .title {
        h3 {
          font-size: 18px;
        }
      }
    }
  }
`;
